import { setSession } from './modules/auth-client.js';
import { getAuthHeader } from './modules/auth-client.js';
import { _cardFlagsCache, setCardFlagsCache, _dismissedFlagsCache, setDismissedFlagsCache } from './core.js';

// Check if user has a valid httpOnly cookie session (when localStorage is empty)
export async function verifyCookieSession() {
  try {
    const resp = await fetch('/api/auth');
    if (!resp.ok) return false;
    const data = await resp.json();
    if (data.authenticated) {
      // Store a marker so isAuthenticated() returns true; cookie handles actual auth
      setSession('__cookie__', data.displayName || data.username);
      return true;
    }
  } catch { /* network error — not authenticated */ }
  return false;
}

// ── Manual refresh (triggered from Activity panel) ──
export async function triggerManualRefresh(btn) {
  if (btn._refreshing) return;
  btn._refreshing = true;
  const orig = btn.textContent;
  btn.textContent = 'Refreshing\u2026';
  btn.disabled = true;
  try {
    await fetch('/api/v1/suggest-next-action', { method: 'POST', headers: getAuthHeader() });
    await refreshCardFlags();
    // renderFromState is called by the caller after this returns
    btn.textContent = 'Done';
    setTimeout(() => { btn.textContent = orig; btn.disabled = false; btn._refreshing = false; }, 2000);
  } catch (_e) {
    btn.textContent = orig;
    btn.disabled = false;
    btn._refreshing = false;
  }
}

// ── Card flags — fetch from API, cache in memory (no cloud sync) ──
export async function refreshCardFlags() {
  try {
    const resp = await fetch('/api/v1/flags', { headers: getAuthHeader() });
    if (resp.status === 401) return;
    if (!resp.ok) return;
    const data = await resp.json();
    setCardFlagsCache(data.flags || {});
    setDismissedFlagsCache(data.dismissed || {});
  } catch (e) {
    console.warn('[Re:Focus] Card flags fetch failed:', e);
  }
}
